(() => {
  if (window.unfoundSmoothScrollInitialized) return;
  window.unfoundSmoothScrollInitialized = true;

  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = matchMedia('(pointer: fine)');
  const ease = 0.096;
  const snapDistance = 0.2;
  let currentY = scrollY;
  let targetY = currentY;
  let frame;

  const maxScroll = () => Math.max(0, document.documentElement.scrollHeight - innerHeight);
  const clamp = (value) => Math.min(maxScroll(), Math.max(0, value));

  const enabled = () => !reducedMotion.matches && finePointer.matches;

  const normalizeDelta = (event) => {
    if (event.deltaMode === WheelEvent.DOM_DELTA_LINE) return event.deltaY * 16;
    if (event.deltaMode === WheelEvent.DOM_DELTA_PAGE) return event.deltaY * innerHeight;
    return event.deltaY;
  };

  const canElementScroll = (element, deltaY, deltaX) => {
    if (!(element instanceof Element)) return false;

    const isVertical = Math.abs(deltaY) >= Math.abs(deltaX);

    for (let node = element; node && node !== document.body; node = node.parentElement) {
      const style = getComputedStyle(node);
      const canScrollY = /(auto|scroll|overlay)/.test(style.overflowY) && node.scrollHeight > node.clientHeight + 1;
      const canScrollX = /(auto|scroll|overlay)/.test(style.overflowX) && node.scrollWidth > node.clientWidth + 1;

      if (isVertical) {
        if (canScrollY && ((deltaY < 0 && node.scrollTop > 0) || (deltaY > 0 && node.scrollTop < node.scrollHeight - node.clientHeight - 1))) {
          return true;
        }
      } else {
        if (canScrollX && ((deltaX < 0 && node.scrollLeft > 0) || (deltaX > 0 && node.scrollLeft < node.scrollWidth - node.clientWidth - 1))) {
          return true;
        }
      }
    }

    return false;
  };

  const step = () => {
    const distance = targetY - currentY;

    if (Math.abs(distance) <= snapDistance) {
      currentY = targetY;
      scrollTo(0, currentY);
      frame = null;
      return;
    }

    currentY += distance * ease;
    scrollTo(0, currentY);
    frame = requestAnimationFrame(step);
  };

  const animateTo = (position) => {
    targetY = clamp(position);
    currentY = scrollY;
    if (!frame) frame = requestAnimationFrame(step);
  };

  addEventListener('wheel', (event) => {
    if (!enabled()) return;
    if (event.ctrlKey || event.metaKey) return;
    if (document.querySelector('dialog[open], details[scroll-lock][open]')) return;
    if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
    if (canElementScroll(event.target, event.deltaY, event.deltaX)) return;

    event.preventDefault();
    targetY = clamp(targetY + normalizeDelta(event));
    if (!frame) {
      currentY = scrollY;
      frame = requestAnimationFrame(step);
    }
  }, { passive: false });

  document.addEventListener('click', (event) => {
    if (!enabled() || event.defaultPrevented) return;

    if (!(event.target instanceof Element)) return;

    const link = event.target.closest('a[href^="#"]');
    if (!link) return;

    const hash = link.getAttribute('href');
    if (hash === '#') return;

    let id;
    try {
      id = decodeURIComponent(hash.slice(1));
    } catch {
      return;
    }

    const target = document.getElementById(id) || document.querySelector(`[name="${CSS.escape(id)}"]`);
    if (!target) return;

    event.preventDefault();
    history.pushState(null, '', hash);
    animateTo(target.getBoundingClientRect().top + scrollY);
  });

  addEventListener('scroll', () => {
    if (frame) return;
    currentY = scrollY;
    targetY = currentY;
  }, { passive: true });

  addEventListener('resize', () => {
    targetY = clamp(targetY);
    currentY = clamp(scrollY);
  });
})();
